import { Component, OnInit, Output, EventEmitter } from '@angular/core';

import { DataForDisplayingMenuItemsService } from '../services/data-for-displaying-menu-items.service';
import { EditRailingColorService } from '../services/edit-railing-color.service';
import { VerticalPicketService } from '../services/vertical-picket.service';

@Component({
  selector: 'app-edit-vertical-picket-type',
  templateUrl: './edit-vertical-picket-type.component.html',
  styleUrls: ['./edit-vertical-picket-type.component.scss']
})
export class EditVerticalPicketTypeComponent {
  @Output() step2Editer = new EventEmitter();
  selectedVerticalPicket;
  verticalPickets = this.verticalPicketService.verticalPickets;

  constructor(
    private dataForMenu: DataForDisplayingMenuItemsService,
    private verticalPicketService: VerticalPicketService,
    private editRailingColorService: EditRailingColorService,
  ) {
    this.dataForMenu.getCurrentParams();
  }

  private _setDefaultSelectedVerticalPicket() {
    const {
      verticalPicketShapeType,
      verticalPicketColorName
    } = this.dataForMenu.getCurrentParams();
    this.selectedVerticalPicket = this.verticalPickets.find(
      vp => vp.shapeType === verticalPicketShapeType && vp.colorName === verticalPicketColorName
    );
    if (verticalPicketColorName.includes('Stainless')) {
      this.dataForMenu.setRailOptions('infillStSteelPickets', true);
      this.dataForMenu.infillStSteelPicketsUpdated.next(true);
    } else {
      this.dataForMenu.setRailOptions('infillStSteelPickets', false);
      this.dataForMenu.infillStSteelPicketsUpdated.next(false);
    }
  }

  ngOnInit() {
    this._setDefaultSelectedVerticalPicket();
    this.dataForMenu.verticalPicketUpdated.subscribe(() => {
      this._setDefaultSelectedVerticalPicket();
    });
  }

  selectVerticalPicket(verticalPicket) {
    if (this.editRailingColorService.confirmTheChangeForEditVerticalPicket(verticalPicket)) {
      return;
    }
    this.selectedVerticalPicket = verticalPicket;
    this.dataForMenu.setVerticalPicket(
      this.selectedVerticalPicket.shapeType,
      this.selectedVerticalPicket.colorName
    );
  }

  goBack(value) {
    this.step2Editer.emit({ name: value });
  }
}



// WEBPACK FOOTER //
// ./src/app/edit-vertical-picket-type/edit-vertical-picket-type.component.ts